import React from 'react';
import { Link } from 'react-router-dom';
import SidebarLeftOne from '../../elements/SidebarLeftOne';

const PracticeLeftSidebarTwoGridSectionOne = () => {
    return(
        <>
        {/*Practice Section*/}
        <section className="practice-section-nobg section-padding-default">
          <div className="default-container">
            <div className="row clearfix">
              <div className="col-lg-8 order-md-2">
                <div className="row clearfix">
                  <div className="col-lg-6 mb-5">
                    <div className="practice-cont-holder">
                      <div className="img-practice">
                        <img src="images/practice/par-01-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                      </div>
                      <div className="practice-box-detail p-4 text-center">
                        <div className="mt-0">
                          <h5 className="font-weight-bold"><Link to="/practice-single-left-sidebar">Bank &amp; Financial</Link></h5>
                          <p>It is a long established fact that a reader will be distracted by the readable content</p>
                          <Link className="read-more text-uppercase font-weight-bold" to="/practice-single-left-sidebar">Read More</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 mb-5">
                    <div className="practice-cont-holder">
                      <div className="img-practice">
                        <img src="images/practice/par-02-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                      </div>
                      <div className="practice-box-detail p-4 text-center">
                        <div className="mt-0">
                          <h5 className="font-weight-bold"><Link to="/practice-single-left-sidebar">Tax &amp; Business Law</Link></h5>
                          <p>It is a long established fact that a reader will be distracted by the readable content</p>
                          <Link className="read-more text-uppercase font-weight-bold" to="/practice-single-left-sidebar">Read More</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 mb-5">
                    <div className="practice-cont-holder">
                      <div className="img-practice">
                        <img src="images/practice/par-03-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                      </div>
                      <div className="practice-box-detail p-4 text-center">
                        <div className="mt-0">
                          <h5 className="font-weight-bold"><Link to="/practice-single-left-sidebar">Car Accidents</Link></h5>
                          <p>It is a long established fact that a reader will be distracted by the readable content</p>
                          <Link className="read-more text-uppercase font-weight-bold" to="/practice-single-left-sidebar">Read More</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 mb-5">
                    <div className="practice-cont-holder">
                      <div className="img-practice">
                        <img src="images/practice/par-04-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                      </div>
                      <div className="practice-box-detail p-4 text-center">
                        <div className="mt-0">
                          <h5 className="font-weight-bold"><Link to="/practice-single-left-sidebar">Property law</Link></h5>
                          <p>It is a long established fact that a reader will be distracted by the readable content</p>
                          <Link className="read-more text-uppercase font-weight-bold" to="/practice-single-left-sidebar">Read More</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 mb-5">
                    <div className="practice-cont-holder">
                      <div className="img-practice">
                        <img src="images/practice/par-05-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                      </div>
                      <div className="practice-box-detail p-4 text-center">
                        <div className="mt-0">
                          <h5 className="font-weight-bold"><Link to="/practice-single-left-sidebar">Criminal Defense</Link></h5>
                          <p>It is a long established fact that a reader will be distracted by the readable content</p>
                          <Link className="read-more text-uppercase font-weight-bold" to="/practice-single-left-sidebar">Read More</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 mb-5">
                    <div className="practice-cont-holder">
                      <div className="img-practice">
                        <img src="images/practice/par-06-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                      </div>
                      <div className="practice-box-detail p-4 text-center">
                        <div className="mt-0">
                          <h5 className="font-weight-bold"><Link to="/practice-single-left-sidebar">Personal Injury</Link></h5>
                          <p>It is a long established fact that a reader will be distracted by the readable content</p>
                          <Link className="read-more text-uppercase font-weight-bold" to="/practice-single-left-sidebar">Read More</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 mb-5">
                    <div className="practice-cont-holder">
                      <div className="img-practice">
                        <img src="images/practice/par-02-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                      </div>
                      <div className="practice-box-detail p-4 text-center">
                        <div className="mt-0">
                          <h5 className="font-weight-bold"><Link to="/practice-single-left-sidebar">Tax &amp; Business Law</Link></h5>
                          <p>It is a long established fact that a reader will be distracted by the readable content</p>
                          <Link className="read-more text-uppercase font-weight-bold" to="/practice-single-left-sidebar">Read More</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 mb-5">
                    <div className="practice-cont-holder">
                      <div className="img-practice">
                        <img src="images/practice/par-05-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                      </div>
                      <div className="practice-box-detail p-4 text-center">
                        <div className="mt-0">
                          <h5 className="font-weight-bold"><Link to="/practice-single-left-sidebar">Criminal Defense</Link></h5>
                          <p>It is a long established fact that a reader will be distracted by the readable content</p>
                          <Link className="read-more text-uppercase font-weight-bold" to="/practice-single-left-sidebar">Read More</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <ul className="cr-pagination-center">
                      <li><Link to="/practice-single-left-sidebar" title><i className="fa fa-angle-left" /></Link></li>
                      <li className="active"><Link to="/practice-single-left-sidebar" title>1</Link></li>
                      <li><Link to="/practice-single-left-sidebar" title>2</Link></li>
                      <li><Link to="/practice-single-left-sidebar" title>3</Link></li>
                      <li><Link to="/practice-single-left-sidebar" title><i className="fa fa-angle-right" /></Link></li>
                    </ul>
                  </div>
                </div>
              </div>
              
              <SidebarLeftOne />

            </div>
          </div>
        </section>
        {/*End Practice Section*/}
        </>
    )
}

export default PracticeLeftSidebarTwoGridSectionOne;